import request from './request'
import {
  parseCareScheduleAssignResponse,
  type CareScheduleAssignTargetType,
} from './CareScheduleAssign'
import type { CareOrderListItem } from './orders'

/** POST `/api/admin/care-schedule/unassign` 请求体（raw-json） */
export interface CareScheduleUnassignRequest {
  target_type: CareScheduleAssignTargetType
  /** 主单为订单主键 `id`；Follow-up 为 follow-up 主键 */
  target_id: number
}

export interface CareScheduleUnassignResponse {
  code: number
  msg: string
  data?: unknown
}

export interface CareScheduleUnassignResult {
  response: CareScheduleUnassignResponse
  /** unassign 成功后后端返回的订单快照（若有，结构与 assign/context 一致） */
  order: CareOrderListItem | null
}

/**
 * 取消已排期（Unassign）：主单 / Follow-up 恢复待排期。
 * Header `token` 由 `request` 拦截器从 localStorage 自动注入。
 */
export async function postCareScheduleUnassign(
  body: CareScheduleUnassignRequest,
): Promise<CareScheduleUnassignResult> {
  const raw = await request.post<CareScheduleUnassignResponse>(
    '/api/admin/care-schedule/unassign',
    body,
  )
  if (raw?.code === 200) {
    return {
      response: raw,
      order: parseCareScheduleAssignResponse(raw),
    }
  }
  const msg =
    typeof raw?.msg === 'string' && raw.msg.trim()
      ? raw.msg
      : 'Failed to cancel schedule'
  throw new Error(msg)
}
